<div class="PolicyDashboard">
    <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label>{{'Please Wait,Processing..'|translate }}</label>
    </div>
    <div class="container-fluid">
        <div class="row">
            <!-- <div class="col-lg-1 col-md-1 hidden-sm hidden-xs"></div> -->
            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div class="col-md-12 proposals">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-xs-12">
                                    <h3 class="panel-title">{{'Motor Policy Cancellation'|translate }}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body">
                            <div class="PaymentForm payFormCancel">
                                <div class="row">
                                    <div
                                        class="card Card_Ar cardcancellationdetails col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <div class="policydetailshead">
                                            <h5 class="cancelpolicy">{{'Policy Info' | translate}}</h5>
                                        </div>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Policy No'|translate}}:</span>
                                            <span class="lbldata policyno">{{objBindInfoRes.PolicyNo}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Insured IDNo'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.InsuredIdNo}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Mobile Number'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.MobileNo}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Total Paid Amount'|translate}}:</span>
                                            <span
                                                class="lbldata">{{objBindInfoRes.TotalPremium  | number : '1.2-2'}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Used Days'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.UsedDays}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Remaining Days'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.RemainingDays}}</span>
                                        </label>

                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Refund Amount'|translate}}:</span>
                                            <span
                                                class="lbldata">{{objBindInfoRes.RefundAmountExcVat  | number : '1.2-2'}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'VAT On Refund Amount'|translate}}:</span>
                                            <span
                                                class="lbldata">{{objBindInfoRes.VatOnRefundAmount  | number : '1.2-2'}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Total Refund Amount'|translate}}:</span>
                                            <span class="lbldata"
                                                style="color: red;">{{objBindInfoRes.RefundAmount  | number : '1.2-2'}}</span>

                                        </label>
                                        <!-- <label class="viewrefunddiv" style="margin-bottom:10px;display: flex;justify-content: center;">
                                            <a data-toggle="modal" data-target="#myModal"
                                                class="viewrefund">{{'View Refund Details' | translate}}</a>
                                        </label> -->
                                        <!-- <label class="cardfeild">
                                            <span class="lbltext">{{'VAT On Refund Amount'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.VatOnRefundAmount  | number : '1.2-2'}}</span>
                                        </label> -->
                                    </div>
                                    <div
                                        class="card Card_Ar cardcancellationdetails col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <div class="policydetailshead">
                                            <h5 class="cancelpolicy">{{'Vehicle Info' | translate}}</h5>
                                        </div>
                                        <label class="cardfeild">
                                            <span class="lbltext">{{'Sequence No / Custom ID'|translate}}:</span>
                                            <span class="lbldata">{{objBindInfoRes.VehicleId}}</span>
                                        </label>
                                        <label class="cardfeild" style="margin-bottom:35px;">
                                            <span class="lbltext">{{'Chasis No'|translate}}:</span>
                                            <span class="lbldata policyno">{{objBindInfoRes.ChassisNo}}</span>
                                        </label>
                                        <label class="cardfeild">
                                            <!-- <div class="lbltext plateno">{{'Plate No'|translate}}</div> -->
                                            <div class="lbldata">
                                                <div class="belt white">
                                                    <!-- <span class="arabic-character">{{objBindInfoRes.PlateTextAr}}</span> -->
                                                    <span class="arabic-character">
                                                        <div class="FirstAr">{{ArabicTextFirstLetter}}</div>
                                                        <div class="SecondAr">{{ArabicTextSecondLetter}}</div>
                                                        <div class="ThirdAr">{{ArabicTextThirdLetter}}</div>
                                                    </span>
                                                    <span class="arabic-number">{{objBindInfoRes.PlateNo}}</span>
                                                    <span class="english-number">{{objBindInfoRes.PlateNo}}</span>
                                                    <!-- <span class="english-character">{{objBindInfoRes.PlateTextEng}}</span> -->
                                                    <span class="english-character">
                                                        <div class="FirstEn">{{EnglishTextFirstLetter}}</div>
                                                        <div class="SecondEn">{{EnglishTextSecondLetter}}</div>
                                                        <div class="ThirdEn">{{EnglishTextThirdLetter}}</div>
                                                    </span>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <form #MotorCancellation="ngForm">
                                    <div class="Field banknamefeild">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <label class="lbltext">{{'Insured Name Arabic'| translate }}</label>
                                                <input type="text" pattern="^[\u0621-\u064A ]+$" class="form-control"
                                                    id="txtInsuredNameAr" name="txtInsuredNameAr" required
                                                    [(ngModel)]="objBindInfoRes.InsuredName_Ar"
                                                    [disabled]="isLockFields==true || !ShowInsuredName_Ar"
                                                    #txtInsuredNameAr="ngModel" autocomplete="off">
                                                <span
                                                    *ngIf="txtInsuredNameAr.invalid && (txtInsuredNameAr.dirty || isSubmitted || txtInsuredNameAr.touched)"
                                                    class="text-danger">
                                                    <div *ngIf="txtInsuredNameAr.errors?.required">
                                                        {{'Insured Arabic Name  is required'| translate }}
                                                    </div>
                                                    <div *ngIf="txtInsuredNameAr.errors?.pattern">
                                                        {{'Insured Name Must Be in Arabic'| translate }}
                                                    </div>
                                                </span>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 bankfeildnamesecond">
                                                <label class="lbltext">{{'Insured Name English'| translate }}</label>
                                                <input type="text" pattern="^[a-zA-Z ]+$" class="form-control"
                                                    id="txtInsuredNameEn" required name="txtInsuredNameEn"
                                                    [(ngModel)]="objBindInfoRes.InsuredName_En"
                                                    [disabled]="isLockFields==true || !ShowInsuredName_En"
                                                    #txtInsuredNameEn="ngModel" autocomplete="off">
                                                <span
                                                    *ngIf="txtInsuredNameEn.invalid && (txtInsuredNameEn.dirty || isSubmitted || txtInsuredNameEn.touched)"
                                                    class="text-danger">
                                                    <div *ngIf="txtInsuredNameEn.errors?.required">
                                                        {{'Insured English Name is required'| translate }}
                                                    </div>
                                                    <div *ngIf="txtInsuredNameEn.errors?.pattern">
                                                        {{'Insured Name Must Be in English'| translate }}
                                                    </div>
                                                </span>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 bankfeildnamesecond">
                                                <label class="lbltext">{{'Cancellation Reason'| translate }}</label>
                                                <select class="form-control" id="txtCancellationReason" selectRequired
                                                    [disabled]="isLockFields==true" name="txtCancellationReason"
                                                    [(ngModel)]="objBindInfoRes.CancellationReason"
                                                    #txtCancellationReason="ngModel">
                                                    <option [value]="0">{{'Select Reason'| translate }}</option>
                                                    <option *ngFor="let Reason of objBindInfoRes.CancellationReasonList"
                                                        [value]="Reason.Code">
                                                        {{Lng=="en"?Reason.Description:Reason.Description_Ar}}</option>
                                                </select>
                                                <span
                                                    *ngIf="txtCancellationReason.invalid && (txtCancellationReason.dirty || isSubmitted || txtCancellationReason.touched)"
                                                    class="text-danger">
                                                    <div *ngIf="txtCancellationReason.errors?.selectRequired">
                                                        {{'Cancellation Reason is required'| translate }}
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <div class="ibandata">
                                    <div class="row iban">
                                        <div class="row">
                                            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 ibanrow">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <label
                                                        class="lbltext ibanlabel">{{'IBAN Number'| translate }}</label>
                                                    <div class="row ibaninputrow">
                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <div class="input-group groupItems">
                                                                <div class="input-group-addon">SA</div>
                                                                <input type="text" class="form-control" id="txtIBAN1"
                                                                    numbersOnly name="txtIBAN1"
                                                                    [(ngModel)]="objBindInfoRes.IBAN1" maxlength="2"
                                                                    #txtIBAN1 [value]="txtIBAN1.value.toUpperCase()"
                                                                    (ngModelChange)="iban1Changed($event)"
                                                                    autocomplete="off"
                                                                    (keypress)="ValidateSpecialCharacters($event)" />
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <input type="text" class="form-control" id="txtIBAN2"
                                                                numbersOnly name="txtIBAN2"
                                                                [(ngModel)]="objBindInfoRes.IBAN2" maxlength="4"
                                                                (blur)="setBankCode(objBindInfoRes.IBAN2)"
                                                                 #txtIBAN2
                                                                [value]="txtIBAN2.value.toUpperCase()"
                                                                (ngModelChange)="iban2Changed($event)"
                                                                autocomplete="off"
                                                                (keypress)="ValidateSpecialCharacters($event)" />
                                                        </div>
                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <input type="text" class="form-control" numbersOnly
                                                                id="txtIBAN3" name="txtIBAN3"
                                                                [(ngModel)]="objBindInfoRes.IBAN3" maxlength="4"
                                                                 #txtIBAN3
                                                                [value]="txtIBAN3.value.toUpperCase()"
                                                                (ngModelChange)="iban3Changed($event)"
                                                                autocomplete="off"
                                                                (keypress)="ValidateSpecialCharacters($event)" />
                                                        </div>
                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <input type="text" class="form-control" id="txtIBAN4"
                                                                numbersOnly name="txtIBAN4"
                                                                [(ngModel)]="objBindInfoRes.IBAN4" maxlength="4"
                                                                 #txtIBAN4
                                                                [value]="txtIBAN4.value.toUpperCase()"
                                                                (ngModelChange)="iban4Changed($event)"
                                                                autocomplete="off"
                                                                (keypress)="ValidateSpecialCharacters($event)" />
                                                        </div>
                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <input type="text" class="form-control" id="txtIBAN5"
                                                                numbersOnly name="txtIBAN5"
                                                                [(ngModel)]="objBindInfoRes.IBAN5" maxlength="4"
                                                                 #txtIBAN5
                                                                [value]="txtIBAN5.value.toUpperCase()"
                                                                (ngModelChange)="iban5Changed($event)"
                                                                autocomplete="off"
                                                                (keypress)="ValidateSpecialCharacters($event)" />
                                                        </div>
                                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 ibanboxdiv">
                                                            <input type="text" class="form-control" id="txtIBAN6"
                                                                numbersOnly name="txtIBAN6"
                                                                [(ngModel)]="objBindInfoRes.IBAN6" maxlength="4"
                                                                 #txtIBAN6
                                                                [value]="txtIBAN6.value.toUpperCase()"
                                                                autocomplete="off"
                                                                (keypress)="ValidateSpecialCharacters($event)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 banknamebind">
                                                <label class="lbltext banknamelabel">{{'Bank Name'| translate }}</label>
                                                <select class="form-control" id="txtBankName" name="txtBankName"
                                                    [disabled]="true" [(ngModel)]="objBindInfoRes.Bankname">
                                                    <option [value]="">--{{'Select Bank' |translate}}---</option>
                                                    <option *ngFor="let bank of objBindInfoRes.bankList"
                                                        [value]="bank.BankCode">
                                                        {{Lng=="en"?bank.BankDesc_Eng:bank.BankDesc_Ar}}</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <label class="lbltext banknamelabel">{{'Bank Holder Name'| translate }}</label>
                                                <input class="form-control" (keypress)="allowEnglishOnly($event)" id="txtAccHolderName" name="txtAccHolderName"
                                                    [(ngModel)]="objBindInfoRes.AccountName" type="text">
                                                <small style="color: red; font-size: 12px;">
                                                    {{'NOTE: Name should contain English letters only' |translate}}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Images Start -->
                                <!-- <div class="row">
                                    <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
                                        <div class="panel panel-default">

                                            <div class="panel-body">
                                                <p class="text-center text-muted">
                                                    <i class="fa fa-camera fa-4x"></i>
                                                </p>
                                                <h4 class="text-center text-muted">
                                                    {{ 'ID Copy' | translate }}
                                                    <small uib-tooltip="For New Arrivals">
                                                        <i class="fa fa-info-circle"></i>
                                                    </small>
                                                    <br>
                                                    <small>({{ 'Scan Copy' | translate
                                                                    }} )</small>

                                                </h4>

                                                <div style="position:relative;">
                                                    <a class="btn btn-block" href='javascript:;'>
                                                        <b style="color:whitesmoke">{{ 'Choose File'
                                                                            | translate
                                                                            }}...</b>

                                                        <input type="file" (change)="OnSelectIDCopyFile($event)"
                                                            style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'
                                                            size="10" accept="image/*" />
                                                        <i class="fa fa-upload"></i>
                                                    </a>

                                                    <img *ngIf="objBindInfoRes.IDCopyImage!=null"
                                                        class="img-thumbnail imgdisplay"
                                                        src="{{'data:image/jpg;base64,' + objBindInfoRes.IDCopyImage}}"
                                                        height="75px">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
                                        <div class="panel panel-default">

                                            <div class="panel-body">
                                                <p class="text-center text-muted">
                                                    <i class="fa fa-camera fa-4x"></i>
                                                </p>
                                                <h4 class="text-center text-muted">
                                                    {{ 'IBAN Copy' | translate }}
                                                    <small uib-tooltip="For New Arrivals">
                                                        <i class="fa fa-info-circle"></i>
                                                    </small>
                                                    <br>
                                                    <small>({{ 'Scan Copy' | translate
                                                                            }} )</small>

                                                </h4>

                                                <div style="position:relative;">
                                                    <a class="btn btn-block" href='javascript:;'>
                                                        <b style="color:whitesmoke">{{ 'Choose File'
                                                                                    | translate
                                                                                    }}...</b>

                                                        <input type="file" (change)="OnSelectIBANFile($event)"
                                                            style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'
                                                            size="10" accept="image/*" />
                                                        <i class="fa fa-upload"></i>
                                                    </a>

                                                    <img *ngIf="objBindInfoRes.IBANCopyImage!=null"
                                                        class="img-thumbnail imgdisplay"
                                                        src="{{'data:image/jpg;base64,' + objBindInfoRes.IBANCopyImage}}"
                                                        height="75px">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                    <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12" *ngIf="objBindInfoRes.CancellationReason==1" >
                                        <div class="panel panel-default">

                                            <div class="panel-body">
                                                <p class="text-center text-muted">
                                                    <i class="fa fa-camera fa-4x"></i>
                                                </p>
                                                <h4 class="text-center text-muted">
                                                    {{ 'Alternate Insurance Copy' | translate }}
                                                    <small uib-tooltip="For New Arrivals">
                                                        <i class="fa fa-info-circle"></i>
                                                    </small>
                                                    <br>
                                                    <small>({{ 'Scan Copy' | translate
                                                                            }} )</small>

                                                </h4>

                                                <div style="position:relative;">
                                                    <a class="btn btn-block" href='javascript:;'>
                                                        <b style="color:whitesmoke">{{ 'Choose File'
                                                                                    | translate
                                                                                    }}...</b>

                                                        <input type="file" (change)="OnSelectAltInsuranceFile($event)"
                                                            style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'
                                                            size="10" accept="image/*" />
                                                        <i class="fa fa-upload"></i>
                                                    </a>

                                                    <img *ngIf="objBindInfoRes.AltInsuranceCopyImage!=null"
                                                        class="img-thumbnail imgdisplay"
                                                        src="{{'data:image/jpg;base64,' + objBindInfoRes.AltInsuranceCopyImage}}"
                                                        height="75px">

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12" *ngIf="objBindInfoRes.CancellationReason==2" > 
                                        <div class="panel panel-default">

                                            <div class="panel-body">
                                                <p class="text-center text-muted">
                                                    <i class="fa fa-camera fa-4x"></i>
                                                </p>
                                                <h4 class="text-center text-muted">
                                                    {{ 'New Owner Istamara Copy' | translate }}
                                                    <small uib-tooltip="For New Arrivals">
                                                        <i class="fa fa-info-circle"></i>
                                                    </small>
                                                    <br>
                                                    <small>({{ 'Scan Copy' | translate
                                                                            }} )</small>

                                                </h4>

                                                <div style="position:relative;">
                                                    <a class="btn btn-block" href='javascript:;'>
                                                        <b style="color:whitesmoke">{{ 'Choose File'
                                                                                    | translate
                                                                                    }}...</b>

                                                        <input type="file" (change)="OnSelectNewOwnerIsthFile($event)"
                                                            style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'
                                                            size="10" accept="image/*" />
                                                        <i class="fa fa-upload"></i>
                                                    </a>

                                                    <img *ngIf="objBindInfoRes.NewOwnerIsthCopyImage!=null"
                                                        class="img-thumbnail imgdisplay"
                                                        src="{{'data:image/jpg;base64,' + objBindInfoRes.NewOwnerIsthCopyImage}}"
                                                        height="75px">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12" *ngIf="objBindInfoRes.CancellationReason==3" > 
                                        <div class="panel panel-default">

                                            <div class="panel-body">
                                                <p class="text-center text-muted">
                                                    <i class="fa fa-camera fa-4x"></i>
                                                </p>
                                                <h4 class="text-center text-muted">
                                                    {{ 'Proof Of Vehicle Dispose Copy' | translate }}
                                                    <small uib-tooltip="For New Arrivals">
                                                        <i class="fa fa-info-circle"></i>
                                                    </small>
                                                    <br>
                                                    <small>({{ 'Scan Copy' | translate
                                                                            }} )</small>

                                                </h4>

                                                <div style="position:relative;">
                                                    <a class="btn btn-block" href='javascript:;'>
                                                        <b style="color:whitesmoke">{{ 'Choose File'
                                                                                    | translate
                                                                                    }}...</b>

                                                        <input type="file" (change)="OnSelectVehDisposeCopyFile($event)"
                                                            style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;'
                                                            size="10" accept="image/*" />
                                                        <i class="fa fa-upload"></i>
                                                    </a>

                                                    <img *ngIf="objBindInfoRes.ProofOfVehDisposeCopyImage!=null"
                                                        class="img-thumbnail imgdisplay"
                                                        src="{{'data:image/jpg;base64,' + objBindInfoRes.ProofOfVehDisposeCopyImage}}"
                                                        height="75px">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div> -->



                                <!-- Images End -->

                       

                                <div class="row" style="margin-top: 40px;">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 agreetermsdiv">
                                        <label class="agreetermscheckbox">
                                            <input type="checkbox" id="Chkterms" name="Chkterms"
                                                class="agreeTerms AgreeCheckBox" [(ngModel)]="agreeTerms"
                                                [disabled]="isLockFields==true" style=" zoom: 1.0;" />
                                        </label>
                                        <label class="agreetermspdf">
                                            <a href="{{url.DocumentURL}}Downloads/GGCITerms&Conditions_Cancellation.pdf"
                                                target="_blank" style="font-weight:bold;font-size:13px;"
                                                download="termsandconditions">{{'I Agree to Policy Terms and Conditions' | translate}}</a>
                                        </label>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 20px;">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 agreetermsdiv">
                                        <label class="agreetermscheckbox">
                                            <input type="checkbox" id="Chkterms" name="Chkterms"
                                                class="agreeTerms AgreeCheckBox" [(ngModel)]="declaration"
                                                [disabled]="isLockFields==true" style=" zoom: 1.0;" />
                                        </label>
                                        <label class="agreetermspdf">
                                            <a (click)="ShowDeclaration()"
                                                style="cursor:pointer;font-weight:bold;font-size:13px;">{{'Declaration' | translate}}</a>
                                        </label>
                                    </div>
                                </div>

                                <div class="row submitbtnrow">
                                    <button class="btn btn-primary btn-block"
                                        [disabled]="isLockFields==true|| !MotorCancellation.valid" name="btnCancel"
                                        id="btnCancel"
                                        (click)="btnSubmit(MotorCancellation.valid)">{{'Submit'| translate }}</button>
                                </div>
                                <div class="Field OTPForm" *ngIf="showOTP">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <label class="Verifi">{{'Verification Code'|translate}}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <input type="text" class="form-control" numbersOnly
                                                        (keypress)="ValidateSpecialChar($event)" maxlength="6"
                                                        [(ngModel)]="OTP">
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 btnsblock">
                                                    <button type="button" class="btn btn-primary Resend verifybtn"
                                                        (click)="VerifyOTP()">{{'Verify'|translate}}</button>
                                                    <button *ngIf="isResendShow" type="button"
                                                        class="btn btn-primary Resend resendbtn"
                                                        (click)="ResendOTP()">{{'Resend'|translate}}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="Field" *ngIf="isShowTimer" style="margin-top:20px;">
                                    <span class="quotelink">{{'You can Resend OTP in '}} {{ timeLeft }}
                                        {{'Seconds'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-1 col-md-1 hidden-sm hidden-xs"></div> -->
        </div>
    </div>
</div>



<!-- <div class="modal fade" id="myModal" data-backdrop="static" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content" style="margin-bottom: 30px !important;">
            <div class="modal-header" style="background-color: #004085;">
                <button type="button" class="close" data-dismiss="modal">X</button>
                <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
                    {{'Refund Details' | translate }}</h4>
            </div>
            <div class="modal-body">
                <table class="table table-striped table-bordered table-list">
                    <tr>
                        <th class="cancellationtableheading">{{'Refund Amount Excluding Deductions'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.RefundAmountExcVat+this.objBindInfoRes.CancellationAdminfee+this.objBindInfoRes.ClaimAmount}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'Admin Fee' | translate }}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.CancellationAdminfee}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'Claim Amount'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.ClaimAmount}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'Refund Amount'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.RefundAmountExcVat}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'VAT Refund Amount'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.VatOnRefundAmount}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'Total Refund Amount'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.RefundAmount}}</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'UPR VAT'|translate}}</th>
                        <td class="cancellationtabledata">0.00</td>
                    </tr>
                    <tr>
                        <th class="cancellationtableheading">{{'Final Refund Amount'|translate}}</th>
                        <td class="cancellationtabledata">{{this.objBindInfoRes.RefundAmount}}</td>
                    </tr>
                </table>
                <div class="row refundpara" style="padding: 0px 25px;">
                    <h3 class="refundamntheading">{{'Refund Amount Calulation' | translate}}</h3>
                    <p class="refundamntcalc">{{'Refund amount = (365- Used Days)/365 * Annual contribution after deducting admin fees(Max amount of SR 25)' |translate }}</p>
                    <p class="note">{{'RCN' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div> -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/Motor_Cancellation/Motor_Cancellation.html